// components/PrescriptionInfo.jsx
import React from 'react';
import { validatePrescription } from '../services/medicationservice';

const PrescriptionInfo = ({ prescription }) => {
  if (!prescription?.trim()) return null;

  const validation = validatePrescription(prescription);

  if (!validation.valid) {
    return (
      <div className="prescription-error" style={{ color: '#d32f2f', fontSize: '0.9em', marginTop: '6px' }}>
        ⚠️ {validation.message}
      </div>
    );
  }

  return (
    <div className="prescription-info" style={{ fontSize: '0.9em', color: '#555', marginTop: '8px' }}>
      <div>
        <strong>Interpretation:</strong> {validation.description}
      </div>
      <div>
        <strong>Interval:</strong> Every {validation.intervalHours.toFixed(1)} hours
        {validation.timesPerDay > 1 && ` (${validation.timesPerDay} times daily)`}
      </div>
      <div style={{ marginTop: '6px', fontSize: '0.82em', color: '#777' }}>
        Examples: 1x1, 1x2, 2x3, 1x4, 2x2
      </div>
    </div>
  );
};

export default PrescriptionInfo;